"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UpdateRecord',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: {},
      listLoading: true,
      listQuery: {
        article_type: 4,
        start: 0,
        total: 10,
        page_num: 1,
        limit: 5
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      if (this.is_load) return;
      this.is_load = true;
      this.listQuery.start++;
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/article/public_list', listQuery).then(function (res) {
        _this.$set(_this.list, res.page, res.list);
        if (res.page_num - 1 > res.page) _this.is_load = false;
      });
    }
  }
};